import { render, staticRenderFns } from "./El.vue?vue&type=template&id=17d4ec74&scoped=true"
import script from "./El.vue?vue&type=script&lang=js"
export * from "./El.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d4ec74",
  null
  
)

export default component.exports